/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientIntakeForm {
    angular.module("meevo.plugins.clientIntakeForm", []);
}